export default function Excel_Synta() {
  return <div>Excel_Synta</div>;
}
